<template lang="pug">
.content
    .row(ref='conditionRow')
        .col-md-12
        .well.well-sm
          div.row
            label.col-md-1 {{label}}

            ed-select.col-md-5.middle(
              v-if='label == "WHEN"',
              :options="operators",
              v-model="operators[1]",
              :disabled="true"
            )
            ed-select.col-md-5.middle(
              v-else
              :options="operators",
              v-model='operatorModel'
              @select='changeOperator($event)'
            )

            slot(
              v-if='label != "WHEN"'
              name='delete-condition')

            div.row(v-for='(condition, i) in processedConditions' :key='i')
              ed-select.col-md-3(
                :options="condition.conditionValues"
                v-model='condition.__selectedContextType'
                label='label'
                :customLabel='getContextLabel'
                placeholder='Select condition context'
                @select="resetConditionLine(condition, $event)"
              )


              ed-select.col-md-3(v-if='condition[xsi] === type.amount || condition[xsi] === type.adjustmentAmount'
                placeholder='Select operator'
                :options='conditionAdditionalOperators'
                v-model='operatorType[condition.AdditionalOperator]'
                @select="changeConditionOperator(condition, $event)"
              )

              ed-select.col-md-3(v-else-if='label == "WHEN"',
                placeholder='Select operator'
                :options='conditionOperators'
                v-model='conditionOperators[0]'
                @select="changeConditionOperator(condition, $event)"
                :disabled="true"
              )

              ed-select.col-md-3(v-else
                placeholder='Select operator'
                :options='conditionOperators'
                v-model='operatorType[condition.Operator]'
                @select="changeConditionOperator(condition, $event)"
              )


              ed-input.col-md-3(v-if='condition[xsi] === type.amount || condition[xsi] === type.adjustmentAmount'
                v-model='condition.Values[type.conditionValue].Value[text]'
                placeholder='0.00'
                amount
                type="money"
                @change="changeConditionAmount(condition, $event)"
              )

              ed-select.col-md-3(v-else-if='condition[xsi] === type.discountPaymentTerms'
                placeholder='Select condition'
                v-model='discountsConditions[0]'
                :options='discountsConditions'
                disabled
                @select="setDiscountsConditionOptions(condition, $event)"
                close-on-select
              )

              ed-select.col-md-3(v-else-if='condition[xsi] === type.preCommit'
                placeholder='Select condition'
                v-model='preCommitConditions[0]'
                :options='preCommitConditions'
                disabled
                @select="setPreCommitConditionOptions(condition, $event)"
                close-on-select
              )

              ed-select.col-md-3(v-else-if='condition[xsi] === type.supplierLocation'
                placeholder='Select condition'
                :value='condition.Values[type.conditionValue].Value ? condition.Values[type.conditionValue].Value[text] : supplierLocationConditions[0]'
                :options='supplierLocationConditions'
                @select="setSupplierLocationConditionOptions(condition, $event)"
                close-on-select
              )

              ed-select.col-md-3(v-else-if='condition[xsi] === type.supplierOrganizationType'
                placeholder='Select condition'
                :value='condition.Values[type.conditionValue].Value ? condition.Values[type.conditionValue].Value[text] : supplierOrganizationTypeConditions[0]'
                :options='supplierOrganizationTypeConditions'
                @select="setSupplierOrganizationTypeConditionOptions(condition, $event)"
                close-on-select
              )

              ed-select.col-md-3(v-else
                placeholder='Select condition'
                :openEndpoint='getEndpoint(condition)'
                multiple
                checkboxes
                multilist
                :options='condition.__o'
                groupLabel='label'
                groupValues='options'
                label='Name'
                trackBy='Uid'
                disableSelected
                :globalSelectedValues='__selectedGlobalOptions'
                :selectedValues='condition.__selectedOp'
                v-model='condition.__selectedOptions'
                @apply='setConditionOptions(condition, $event)'
                @open='condition.__selectedContextType && getConditionOptions(condition, $event)')

              //- p __selectedContextType {{condition.__selectedContextType}}
              //- p __selectedOptions {{condition.__selectedOptions}}
              //- p condition.__o {{condition.__o}}
              .col-md-3.icon-bar
                div.fas.fa-trash-alt.pull-right(@click='deleteConditionModal(condition)')
                div.fas.fa-copy.pull-right(@click='copyConditionLine(condition.Id, i)')
    ed-modal(
      :show='showDeleteModal'
      @close='showDeleteModal = false'
      @confirm='deleteConditionLine()'
      title=''
      subtitle='Are you sure you want to delete this condition?'
      primaryButton='Yes'
      secondaryButton='No'
      type='small'
    )
</template>

<script>
import type from './type'
import optionType from './option-type'
import contextType from './context-type'
import teamTabType from './team-tab-type'
import conditionType from './condition-type'
import operatorType from './operator-type'
import optionRules from './option-rules'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'
var approvalRuleUtils = require('./approvalRuleUtils')

export default {
  props: {
    conditions: Object,
    label: String,
    rule: Object,
    conditionOptions: Object,
    existingOperator: String
  },

  created() {
    EventBus.$on('rootOptionChanged', limitation => {
      this.setIfSelectionLimitations()
    })

    this.processConditions()
    EventBus.$on(events.APPROVAL_RULE.VALIDATE_COMPONENTS, this.validateRule)
  },

  // solution from this link does not work
  // https://stackoverflow.com/questions/45399302/stop-receiving-events-from-destroyed-child-component
  beforeDestroy() {
    this.componentDestroyed = true
  },

  computed: {
    conditionOperators() {
      return this.conditionOptions.Operators ? this.conditionOptions.Operators : []
    },

    conditionAdditionalOperators() {
      return this.conditionOptions.AdditionalOperators ? this.conditionOptions.AdditionalOperators : []
    },

    discountsConditions() {
      return ['Overridden']
    },

    preCommitConditions() {
      return ['Pre-Commit']
    },

    supplierLocationConditions() {
      return ['Domestic', 'Foreign']
    },

    supplierOrganizationTypeConditions() {
      return ['Company', 'Individual']
    },

    operatorModel() {
      if (this.rule && this.rule.Operator) {
        return this.rule.Operator === 'And' ? this.operators[0] : this.operators[1]
      }
    },

    programLabel() {
      return global.app.$user.sessionSettings.CompanySettings.ProgramLabel
    }
  },

  data () {
    return {
      processedConditions: [],
      operators: [
        'All child conditions below are true (AND)',
        'Any child conditions below are true (OR)'
      ],
      list: utils.collection.list,
      max: utils.collection.max,
      condOptions: [],
      showDeleteModal: false,
      deleteTarget: null,
      contextType: contextType,
      xsi: '@xsi:type',
      text: '#text',
      contextTypeMap: Object.keys(contextType),
      operatorTypeMap: Object.keys(operatorType),
      resultOptions: {},
      values: condition => {
        var result = []
        if (condition.Values) {
          var valuesList = condition.Values[type.conditionValue] && this.list(condition.Values[type.conditionValue]).length > 0 &&
            this.list(condition.Values[type.conditionValue]).map(value => {
              let name = this.conditionTypeMap.filter(key => key === value.Value['#text'])[0]
                ? conditionType[value.Value['#text']]
                : value.Value['#text']
              value = {
                Name: name,
                Id: parseInt(value.Id)
              }
              return value
            }) || []
          result.push({
            label: contextType[condition[this.xsi]],
            type: 'Result',
            options: valuesList
          })
        }

        if (condition.Roles) {
          var roles = condition.Roles[type.role] && this.list(condition.Roles[type.role]).filter(key => key.IsTeamTabRole === 'false' && key.IsUserTitle !== 'true').map(role => {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            }
            return role
          }) || []

          var teamTabRoles = condition.Roles[type.role] && this.list(condition.Roles[type.role]).filter(key => key.IsTeamTabRole === 'true').map(role => {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId),
              Key: role.TeamTabRole
            }
            return role
          }) || []

          var usersTitles = condition.Roles[type.role] && this.list(condition.Roles[type.role]).filter(key => key.IsUserTitle === 'true').map(role => {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            }
            return role
          }) || []

          result.push({
            label: optionType['Roles'],
            type: 'Roles',
            options: roles
          })
          result.push({
            label: optionType['TeamTabRoles'],
            type: 'TeamTabRoles',
            options: teamTabRoles
          })
          result.push({
            label: optionType['UsersTitles'],
            type: 'UsersTitles',
            options: usersTitles
          })
        }
        if (condition.Users) {
          var users = condition.Users[type.user] && this.list(condition.Users[type.user]).map(user => {
            user = {
              Name: user.FirstName + ' ' + user.LastName,
              Id: parseInt(user.UserID)
            }
            return user
          }) || []
          result.push({
            label: optionType['Users'],
            type: 'Users',
            options: users
          })
        }
        return result
      },
      __selectedGlobalOptions: [],
      conditionTypeMap: Object.keys(conditionType),
      type,
      operatorType,
      optionRules,
      componentDestroyed: false
    }
  },

  methods: {
    validateRule() {
      if (!this.componentDestroyed) {
        let valid = true

        // verify condition values
        if (this.conditions && this.conditions[type.condition] && this.list(this.conditions[type.condition]).length > 0) {
          let conditionsList = this.list(this.conditions[type.condition])

          conditionsList.map(condition => {
            // verify first 2 dropdowns on condition line
            if (!condition['@xsi:type'] || !condition.Operator) {
              valid = false
            } else {
              // verify if any value is set on condition
              if (condition.Values && condition.Values[type.conditionValue] && this.list(condition.Values[type.conditionValue]).length > 0) {
                let valuesList = this.list(condition.Values[type.conditionValue])
                valuesList.map(valueItem => {
                  if (!valueItem.Value || !valueItem.Value['#text']) {
                    valid = false
                  }
                })
              } else {
                // verify if any role/user is set on condition
                let missingRoles = false
                let missingUsers = false
                if (!condition.Roles || (condition.Roles && (!condition.Roles[type.role] || this.list(condition.Roles[type.role]).length === 0))) {
                  missingRoles = true
                }
                // verify if any user is set on condition
                if (!condition.Users || (condition.Users && (!condition.Users[type.user] || this.list(condition.Users[type.user]).length === 0))) {
                  missingUsers = true
                }
                if (missingRoles && missingUsers) {
                  valid = false
                }
              }
            }

            let payload = {
              Id: condition.Id,
              valid: valid
            }
            EventBus.$emit(events.APPROVAL_RULE.VALIDATION_COMPLETED, payload)
          })
        }

        if (!valid) {
          this.invalidateConditionBlock()
        } else {
          this.resetConditionBlock()
        }
      }
    },

    invalidateConditionBlock() {
      if (this.$refs.conditionRow && this.$refs.conditionRow.classList) {
        this.$refs.conditionRow.classList.add('invalid')
      }
    },

    resetConditionBlock() {
      if (this.$refs.conditionRow && this.$refs.conditionRow.classList) {
        this.$refs.conditionRow.classList.remove('invalid')
      }
    },

    getContextLabel(option, label) {
      if (option[label] === 'Division') {
        return this.$user.$.settings['DivisionName']
      } else if (option[label] === contextType['MeetingTypeConditionDTO']) {
        return global.app.$user.sessionSettings.CompanySettings.Labels.MeetingTypeLabel
      }
      return option[label]
    },

    applyConditionContext (condition, index) {
      // get context options
      const rootOp = this.conditionOptions && this.conditionOptions.RootOptions
      const ops = this.conditionOptions && this.conditionOptions.Options

      condition.__selectedOptions = []
      condition.__selectedContextType = ''
      condition.__o = [{}]
      condition.__selectedOp = []

      condition.conditionValues = []
      // this.__selectedGlobalOptions = []
      // apply context options (root level)
      if (this.$parent && this.$parent.isRoot) {
        if (rootOp) {
          rootOp.map((o, index) => {
            condition.conditionValues.push({
              label: this.$t(this.formatLabel(contextType[o])),
              values: o === condition['@xsi:type'] ? this.values(condition) : [{label: '', options: []}]
            })
            if (o === condition['@xsi:type']) {
              condition.__selectedContextType = condition.conditionValues[index]
              this.setThenSelectionLimitations(condition)
            }
          })
        }
      // apply context options
      } else {
        if (ops) {
          // limitate IF options based on what was selected on WHEN condition
          this.conditionOptions = this.limitateOptions(this.conditionOptions)
          this.conditionOptions.Options.map((o, index) => {
            condition.conditionValues.push({
              label: this.$t(contextType[o]),
              values: o === condition['@xsi:type'] ? this.values(condition) : [{label: '', options: []}]
            })
            if (o === condition['@xsi:type']) {
              condition.__selectedContextType = condition.conditionValues[index]
            }
          })
        }
      }

      // set initial values
      // TODO: get default group
      this.markGroupOptions({ data: '{"Roles": []}' }, condition, true)

      return condition
    },

    limitateOptions(conditionOptions) {
      // get original options from $store
      this.conditionOptions.Options = utils.copy(this.$store.state.originalConditionOptions.options)
      for (let [i, value] of conditionOptions.Options.entries()) {
        if (!this.$store.state[optionRules.InvoiceSelected] && !this.$store.state[optionRules.PoSelected]) {
          if (value === type.evedPayStatus) {
            conditionOptions.Options.splice(i, 1)
          }
        }
      }
      return conditionOptions
    },
    /*
     * 1. init condition model
     */
    processConditions() {
      var vm = this
      this.__selectedGlobalOptions = []
      // set conditon model
      this.processedConditions = this.list(utils.copy(this.conditions)[type.condition]).map((condition, index) => {
        condition = vm.applyConditionContext(condition, index)
        return condition
      })
    },

    /*
     * 2. fetch all options
     */
    getConditionOptions(condition, e) {
      let vm = this
      let endpoint = this.getEndpoint(condition)
      let payload = this.getPayload(condition)
      // call api
      endpoint && this.api.forms.post(endpoint, payload).then(r => {
        if (r && r.data) {
          vm.markGroupOptions(r, condition, false)
        }
      })
    },

    /*
     * 3. mark existing options
     */
    markGroupOptions(r, condition, isInitiallySetting) {
      //
      let resultObj = JSON.parse(r.data)
      let selectedType = Object.keys(resultObj).length === 1 && !isInitiallySetting ? contextType[condition[this.xsi]] : null
      selectedType = this.formatLabel(selectedType)
      let initialSelected = condition.__selectedContextType.values
                              ? condition.__selectedContextType.values
                                  .map(flagSaved)
                                  .reduce((selectedOptions, value) => selectedOptions.concat(value), [])
                              : []

      let newCondition = [{ label: '', values: [{label: '', options: []}] }]

      resultObj = resultObj.constructor === Array ? { Result: resultObj } : resultObj
      Object.keys(resultObj).map((key, i) => {
        var res = resultObj[key].map(k => {
          k.Uid = k.Id + '_' + key + '_' + condition.__selectedContextType.label
          k.Type = key
          k.Name = this.formatLabel(k.Name)
          return k
        })
        newCondition = condition.conditionValues.filter(v => (v.label === selectedType) || (v.label === contextType[condition['@xsi:type']]))[0]
        condition.__selectedOptions = condition.__selectedOptions.length
                                    ? condition.__selectedOptions
                                    : initialSelected
        if (isInitiallySetting) {
          condition.__selectedOp = utils.copy(condition.__selectedOptions)
        }
        condition.__selectedOptions.map(option => {
          if (this.__selectedGlobalOptions.filter(o => o.Uid === option.Uid).length === 0 && (isInitiallySetting ? true : condition.__selectedOp.filter(o => o.Uid === option.Uid).length !== 0)) {
            this.__selectedGlobalOptions.push(option)
          }
        })

        if (newCondition) {
          let useHierarchyApproval = this.$user.$.companySettings && this.$user.$.companySettings.UseHierarchyApproval

          var validOption =
            (!useHierarchyApproval && key !== 'UsersTitles') ||
            (useHierarchyApproval &&
              (
                (!this.$store.state[optionRules.ProgramBudgetSelected] && key !== 'UsersTitles') ||
                this.$store.state[optionRules.ProgramBudgetSelected]
              )
            )

          if (validOption) {
            if (newCondition.values[i]) {
              newCondition.values[i].label = selectedType || optionType[key]
              newCondition.values[i].options = res
            } else {
              newCondition.values.push({
                label: selectedType || optionType[key],
                options: res
              })
            }
          }
        }
      })

      this.setThenSelectionLimitations(condition)
      newCondition && this.setOptions(condition, newCondition)

      function flagSaved (val) {
        return val.options.map(k => {
          k.Uid = k.Id + '_' + (selectedType !== null ? optionType['Result'] : val.type) + '_' + condition.__selectedContextType.label
          k.Type = (selectedType !== null ? optionType['Result'] : val.type)
          // k.Key = k.Key
          return k
        })
      }
    },

    setThenSelectionLimitations(condition) {
      if (this.$parent.isRoot) {
        // The Notify action should be available only if on the WHEN section I chose the PO
        this.$store.state[optionRules.PoSelected] = (condition['@xsi:type'] === type.po)

        // When selecting the Closed/Cancelled option for PO condition only the Notify action should appear
        let cancelledLimitation = false
        let closedLimitation = false
        condition.__selectedOptions.map(option => {
          if (option.Name === conditionType.Closed) {
            closedLimitation = true
          }
          if (option.Name === conditionType.Cancelled) {
            cancelledLimitation = true
          }
        })
        this.$store.state[optionRules.PoCancelledClosedSelected] = (
          condition['@xsi:type'] === type.po &&
          (
            (cancelledLimitation && closedLimitation) && condition.__selectedOptions.length === 2) ||
            (((cancelledLimitation && !closedLimitation) || (!cancelledLimitation && closedLimitation)) && condition.__selectedOptions.length === 1)
          )

        this.$store.state[optionRules.InvoiceSelected] = (condition['@xsi:type'] === type.invoice)
        this.$store.state[optionRules.ProgramBudgetSelected] = (condition['@xsi:type'] === type.programBudget)
      }
    },

    setIfSelectionLimitations() {
      // The EvedPay Status option should be available
      // only if the PO/INVOICE option was selected on WHEN condition
      if (this.$store.state[optionRules.PoSelected] || this.$store.state[optionRules.InvoiceSelected]) {
        let alreadyContainsItem = false
        this.processedConditions.map(condition => {
          condition.conditionValues.map(conditionValue => {
            if (conditionValue.label === this.contextType[type.evedPayStatus]) {
              alreadyContainsItem = true
            }
          })
          if (!alreadyContainsItem && !this.$parent.isRoot) {
            condition.conditionValues.push({
              label: this.contextType[type.evedPayStatus],
              values: [{label: '', options: []}]
            })
          }
          return condition
        })
      } else {
        // remove EvedPay Status option from IF condition context
        this.processedConditions.map(condition => {
          for (let [i, value] of condition.conditionValues.entries()) {
            if (value.label === this.contextType[type.evedPayStatus]) {
              condition.conditionValues.splice(i, 1)
              break
            }
          }
          // if there are conditions with EvedPay Status option selected then reset them
          if (condition.__selectedContextType.label === this.contextType[type.evedPayStatus]) {
            this.resetConditionLine(condition, {label: '', values: [{label: '', options: []}]})
          }

          // remove Discount Payment Terms
          for (let [i, value] of condition.conditionValues.entries()) {
            if (value.label === this.contextType[type.discountPaymentTerms]) {
              condition.conditionValues.splice(i, 1)
              break
            }
          }
          // if there are conditions with Discount Payment Terms option selected then reset them
          if (condition.__selectedContextType.label === this.contextType[type.discountPaymentTerms]) {
            this.resetConditionLine(condition, {label: '', values: [{label: '', options: []}]})
          }

          // remove Pre-Commit
          for (let [i, value] of condition.conditionValues.entries()) {
            if (value.label === this.contextType[type.preCommit]) {
              condition.conditionValues.splice(i, 1)
              break
            }
          }
          // if there are conditions with Pre-commit option selected then reset them
          if (condition.__selectedContextType.label === this.contextType[type.preCommit]) {
            this.resetConditionLine(condition, {label: '', values: [{label: '', options: []}]})
          }
          if (condition.__selectedContextType.label === this.contextType[type.supplierLocation]) {
            this.resetConditionLine(condition, {label: '', values: [{label: '', options: []}]})
          }
          if (condition.__selectedContextType.label === this.contextType[type.supplierOrganizationType]) {
            this.resetConditionLine(condition, {label: '', values: [{label: '', options: []}]})
          }
          return condition
        })
      }
    },
    //
    getEndpoint(condition) {
      var endpoint = ''
      switch (condition['@xsi:type']) {
        case type.po:
        case type.invoice:
        case type.expense:
        case type.scope:
        case type.evedPay:
        case type.programBudget:
        case type.evedPayStatus:
          endpoint = this.api.$.approval.getConditionOptions
          break

        case type.division:
          endpoint = this.api.$.approval.getDivisions
          break
        case type.businessUnit:
          endpoint = this.api.$.approval.getBusinessUnits
          break
        case type.costCenter:
          endpoint = this.api.$.approval.getCostCenters
          break
        case type.meetingType:
          endpoint = this.api.$.approval.getMeetingTypes
          break
        case type.category:
          endpoint = this.api.$.approval.getCategories
          break
        case type.itemOwner:
          endpoint = this.api.$.approval.getItemOwnerValues
          break
        case type.programTeamMember:
          // TBD in the future
          break
      }
      return endpoint
    },

    getPayload(condition) {
      var payload = {}
      switch (condition['@xsi:type']) {
        case type.po:
        case type.invoice:
        case type.expense:
        case type.scope:
        case type.evedPay:
        case type.programBudget:
        case type.evedPayStatus:
          payload = {
            type: condition['@xsi:type']
          }
          break
      }

      return payload
    },

    setDiscountsConditionOptions(condition, e) {
      this.enableSaveButton()

      condition.Users = null
      condition.Roles = null
      condition.Values[type.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }]

      // this.rootOptionsChangedEvent(condition)

      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
    },

    setPreCommitConditionOptions(condition, e) {
      this.enableSaveButton()

      condition.Users = null
      condition.Roles = null
      condition.Values[type.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }]

      // this.rootOptionsChangedEvent(condition)

      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
    },

    setSupplierLocationConditionOptions(condition, e) {
      this.enableSaveButton()

      condition.Users = null
      condition.Roles = null
      condition.Values[type.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }]

      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
    },

    setSupplierOrganizationTypeConditionOptions(condition, e) {
      this.enableSaveButton()

      condition.Users = null
      condition.Roles = null
      condition.Values[type.conditionValue] = [{
        Id: 0,
        Value: {
          '@xsi:type': 'xsd:string',
          '#text': e
        },
        'CurrencyId': '1',
        'CurrencyCode': 'USD'
      }]

      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
    },

    getTeamTabType(searchKey) {
      let result = searchKey
      Object.keys(teamTabType).map(key => {
        let keyF = key.replace('[placeholder]', this.programLabel)
        if (keyF === searchKey) {
          result = teamTabType[key]
        }
      })
      return result
    },

    setConditionOptions(condition, e) {
      this.enableSaveButton()

      const simpleList = []
      const RolesList = []
      const UsersList = []

      condition.__selectedOptions.map(selectedOption => {
        if (this.__selectedGlobalOptions.filter(o => o.Uid === selectedOption.Uid).length === 0) {
          this.__selectedGlobalOptions.push(selectedOption)
        }
        this.processedConditions.map(processedCondition => {
          if (processedCondition.Id !== condition.Id) {
            processedCondition.__selectedOptions.map((option, index) => {
              if (option.Uid === selectedOption.Uid) {
                processedCondition.__selectedOptions.splice(index, 1)
              }
              return option
            })
            return processedCondition
          }
        })
        switch (selectedOption.Type) {
          case optionType['Roles']:
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: this.getTeamTabType(this.programLabel + ' Owner'), // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'false'
            })
            break

          case 'TeamTabRoles':
            var teamTabText = ''
            if (selectedOption.Key === this.getTeamTabType('Meeting Requestor')) {
              teamTabText = this.getTeamTabType('Meeting Requestor')
            } else {
              if (selectedOption.Id >= 0) {
                teamTabText = this.getTeamTabType(selectedOption.Name)
              } else {
                teamTabText = this.getTeamTabType('Custom Title')
              }
            }

            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: teamTabText,
              CustomTitleId: (selectedOption.Id >= 0 ? selectedOption.Id : ((-1) * selectedOption.Id)),
              Name: selectedOption.Name,
              IsTeamTabRole: 'true',
              IsUserTitle: 'false'
            })
            break

          case optionType['Users']:
            UsersList.push({
              UserID: selectedOption.Id,
              RoleID: 0,
              FirstName: selectedOption.Name.split(' ')[0],
              LastName: selectedOption.Name.split(' ')[1]
            })
            break

          case 'UsersTitles':
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: this.getTeamTabType(this.programLabel + ' Owner'), // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'true'
            })
            break

          default:
            let text = this.conditionTypeMap.filter(key => conditionType[key] === selectedOption.Name)[0]
              ? this.conditionTypeMap.filter(key => conditionType[key] === selectedOption.Name)[0]
              : selectedOption.Name
            simpleList.push({
              Id: selectedOption.Id,
              Value: {
                '@xsi:type': 'xsd:string',
                '#text': text
              },
              'CurrencyId': '1',
              'CurrencyCode': 'USD'
            })
            break
        }
      })

      if (condition.__selectedContextType.label !== contextType.ItemOwnerConditionDTO) {
        if (simpleList.length > 0) {
          if (!condition.Values) {
            condition.Values = {}
          }
          condition.Values[type.conditionValue] = (simpleList.length === 1 ? simpleList[0] : simpleList)
        } else {
          condition.Values = null
        }
        condition.Roles = null
        condition.Users = null
      } else {
        if (RolesList.length > 0) {
          if (!condition.Roles) {
            condition.Roles = {}
          }
          condition.Roles[type.role] = (RolesList.length === 1 ? RolesList[0] : RolesList)
        } else {
          condition.Roles = null
        }
        if (UsersList.length > 0) {
          if (!condition.Users) {
            condition.Users = {}
          }
          condition.Users[type.user] = (UsersList.length === 1 ? UsersList[0] : UsersList)
        } else {
          condition.Users = null
        }
        condition.Values = null
      }

      var updatedCondition = utils.copy(condition)
      let copyselectedOp = utils.copy(condition.__selectedOp)
      this.__selectedGlobalOptions.map(option => {
        if (copyselectedOp.filter(o => o.Uid === option.Uid).length !== 0 && condition.__selectedOptions.filter(o => o.Uid === option.Uid).length === 0) {
          this.__selectedGlobalOptions.splice(this.__selectedGlobalOptions.indexOf(option), 1)
        }
      })
      condition.__selectedOp = utils.copy(condition.__selectedOptions)
      this.rootOptionsChangedEvent(condition)
      this.updateCondition(condition.Id, updatedCondition)
    },

    updateCondition(conditionId, updatedCondition) {
      delete updatedCondition.__selectedOptions
      delete updatedCondition.__selectedContextType
      delete updatedCondition.__o
      delete updatedCondition.conditionValues
      delete updatedCondition.__selectedOp

      let payload = {
        Id: conditionId,
        Condition: updatedCondition
      }

      this.$emit('updateCondition', payload)
    },

    setOptions(condition, e) {
      condition.__o = e.values
      e.values = [{label: '', options: []}]
    },

    resetConditionLine(condition, e) {
      this.enableSaveButton()
      let copyselectedOp = utils.copy(condition.__selectedOp)
      let copyselectedOptions = utils.copy(condition.__selectedOptions)
      this.__selectedGlobalOptions.map(option => {
        if (copyselectedOp.filter(o => o.Uid === option.Uid).length !== 0 && copyselectedOptions.filter(o => o.Uid === option.Uid).length !== 0) {
          this.__selectedGlobalOptions.splice(this.__selectedGlobalOptions.indexOf(option))
        }
      })
      if (this.$parent.isRoot) {
        condition.Operator = operatorType.Is
      } else {
        condition.Operator = null
      }
      condition.__selectedOptions = []
      condition.__selectedContextType = ''
      condition.__o = [{}]
      condition.__selectedOp = []

      condition[this.xsi] = this.contextTypeMap.filter(key => this.formatLabel(contextType[key]) === e.label)[0]
      if (condition[this.xsi] === type.itemOwner) {
        condition.Values = null
        condition.Roles = {
          RoleDTO: null
        }
        condition.Users = {
          UserDTO: null
        }
      } else {
        condition.Values = {
          ConditionValueDTO: {
            Id: 0,
            Value: {
              '@xsi:type': 'xsd:string',
              '#text': ''
            },
            'CurrencyId': '1',
            'CurrencyCode': 'USD'
          }
        }
      }

      if (condition[this.xsi] === type.amount || condition[this.xsi] === type.adjustmentAmount) {
        condition.Values[type.conditionValue].Value[this.xsi] = 'xsd:double'
        condition.Operator = operatorType.Is
      }
      if (condition.AdditionalOperator) {
        delete condition.AdditionalOperator
      }
      if (condition[this.xsi] === type.discountPaymentTerms) {
        this.setDiscountsConditionOptions(condition, this.discountsConditions[0])
      }
      if (condition[this.xsi] === type.preCommit) {
        this.setPreCommitConditionOptions(condition, this.preCommitConditions[0])
      }
      if (condition[this.xsi] === type.supplierLocation) {
        this.setSupplierLocationConditionOptions(condition, this.supplierLocationConditions[0])
      }
      if (condition[this.xsi] === type.supplierOrganizationType) {
        this.setSupplierOrganizationTypeConditionOptions(condition, this.supplierOrganizationTypeConditions[0])
      }

      this.rootOptionsChangedEvent(condition)
      this.setOptions(condition, e)
      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
    },

    rootOptionsChangedEvent(condition) {
      this.setThenSelectionLimitations(condition)
      EventBus.$emit('rootOptionChanged')
    },

    changeConditionOperator(condition, e) {
      if (condition[this.xsi] === type.amount || condition[this.xsi] === type.adjustmentAmount) {
        condition.AdditionalOperator = this.operatorTypeMap.filter(key => operatorType[key] === e)[0]
        condition.Operator = operatorType['Is']
      } else {
        condition.Operator = this.operatorTypeMap.filter(key => operatorType[key] === e)[0]
        delete condition.AdditionalOperator
      }
      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
      this.enableSaveButton()
    },

    changeConditionAmount(condition, e) {
      condition.Values[type.conditionValue].Value['#text'] = e
      condition.Values[type.conditionValue].Value['@xsi:type'] = 'xsd:double'
      var updatedCondition = utils.copy(condition)
      this.updateCondition(condition.Id, updatedCondition)
      this.enableSaveButton()
    },

    changeOperator(e) {
      this.rule.Operator = e === this.operators[0] ? 'And' : 'Or'
      let updatedOperator = utils.copy(this.rule.Operator)
      this.$emit('changeOperator', updatedOperator)
      this.enableSaveButton()
    },

    deleteConditionModal(condition) {
      this.showDeleteModal = true
      this.deleteTarget = condition
    },

    deleteConditionLine() {
      this.processedConditions.splice(this.processedConditions.indexOf(this.deleteTarget), 1)
      this.deleteTarget.__selectedOp.map(option => {
        if (this.__selectedGlobalOptions.filter(o => o.Uid === option.Uid).length !== 0) {
          var index = this.__selectedGlobalOptions.map(op => {
            return op.Uid
          }).indexOf(option.Uid)
          this.__selectedGlobalOptions.splice(index, 1)
        }
      })
      this.$emit('deleteLine', this.deleteTarget)
      this.enableSaveButton()
    },

    copyConditionLine: function(conditionLineId, index) {
      let newCondition = utils.copy(this.processedConditions[index])
      const id = this.max(this.$store.state.approvalRuleIds.conditionIds) + 1

      newCondition.Id = id
      this.$store.state.approvalRuleIds.conditionIds.push(id)

      const sanitizedNewCondition = utils.copy(newCondition)
      delete sanitizedNewCondition.__selectedOptions
      delete sanitizedNewCondition.__selectedContextType
      delete sanitizedNewCondition.__o
      delete sanitizedNewCondition.conditionValues
      delete sanitizedNewCondition.__selectedOp

      this.processedConditions.splice(index + 1, 0, newCondition)
      this.$emit('copyLine', sanitizedNewCondition)
      this.enableSaveButton()
    },

    addCondition(newCondition) {
      newCondition.Id = this.max(this.$store.state.approvalRuleIds.conditionIds) + 1
      this.$store.state.approvalRuleIds.conditionIds.push(newCondition.Id)
      var newCond = utils.copy(newCondition)

      if (this.processedConditions.constructor === Array) {
        this.processedConditions.push(this.applyConditionContext(newCond))
        const sanitizedNewCondition = utils.copy(newCondition)
        delete sanitizedNewCondition.__selectedOptions
        delete sanitizedNewCondition.__selectedContextType
        delete sanitizedNewCondition.__o
        delete sanitizedNewCondition.conditionValues
        delete sanitizedNewCondition.__selectedOp
        this.$emit('addLine', sanitizedNewCondition)
        return
      }
    },

    enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton)
    },

    formatLabel(value) {
      if (typeof value !== 'string') return value
      return value.replace('Program', this.programLabel)
    }
  }
}
</script>

<style scoped lang='scss'>
  .invalid {
    background: #ffb3b3 !important;
  }
@import "~@/assets/sass/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/_modules/Approvals/Approval-rule/condition.vue